@import 'styles/mixins';
@import 'styles/variables';

.loader {
  animation: spin 2s linear infinite;
  border: 2px solid var(--light-10);
  border-top: 2px solid var(--selected-stroke);
  border-radius: 50%;
  height: 24px;
  width: 24px;
  margin: auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
